import React, { Component } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, ArcElement, BarElement, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { Line, Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment';
import 'moment/locale/es';
import { connect } from 'react-redux';
import Menu from '../menu';
import CalendarIcon from '../../assets/icons/calendar.png';
import EmergencyIcon from '../../assets/img/emergency.gif';
import PlansNew from '../../assets/img/plan-image.png';
import { Dashboard as DashboardService, User as UserService } from '../../services';
import { Constants, Globals } from '../../utils';

ChartJS.register(
  ArcElement, CategoryScale, LinearScale, BarElement,
  PointElement, LineElement, Title, Tooltip, Legend, Filler, ChartDataLabels
);

moment.locale('es');

const PALETTE = ['#4481eb', '#f7b731', '#20bf6b', '#fc5c65', '#a55eea', '#fd9644', '#0fb9b1'];

const fmt = (n) => Globals.formatMiles(n || 0);
const round2 = (n) => parseFloat(parseFloat(n || 0).toFixed(2));

const getColor = (i) => PALETTE[i % PALETTE.length];

const MONTH_MAP = {
  January: 'Ene', February: 'Feb', March: 'Mar', April: 'Abr',
  May: 'May', June: 'Jun', July: 'Jul', August: 'Ago',
  September: 'Sep', October: 'Oct', November: 'Nov', December: 'Dic',
};

class Dashboard extends Component {

  state = {
    greeting: '',
    top_5_products: [],
    top_5_clients: [],
    cuentas_cobrar_pagar: { total_cobrar: 0, total_pagar: 0 },
    orders_months: [],
    orders_today: 0,
    orders_totals: 0,
    sellers_sales: [],
    status_receivable: { 'Por aprobar': 0, 'Vencida': 0, 'Próxima a vencer': 0 },
    status_orders: { 'En proceso': 0, 'Procesado': 0, 'Anulado': 0 },
    status_dispatch: { 'Por entregar': 0, 'Despachado': 0 },
    visits: [],
    plan: null,
    hasPendingPayments: true,
  };

  componentDidMount() {
    this.load();
    this.getProfile();
  }

  load = async () => {
    try {
      const res = await DashboardService.getAdminDashboard({ user_id: this.props.user.id });

      const orders_months = Object.entries(res.orders_months || {}).map(([key, val]) => ({
        monthName: MONTH_MAP[key] || key,
        amount: val,
      }));

      this.setState({
        greeting: res.greeting || '',
        cuentas_cobrar_pagar: res.cuentas_cobrar_pagar || { total_cobrar: 0, total_pagar: 0 },
        orders_months,
        orders_today: res.orders_today || 0,
        orders_totals: res.orders_totals || 0,
        sellers_sales: (res.sellers_sales || []).sort((a, b) => b.total - a.total).slice(0, 5),
        top_5_products: res.top_5_products || [],
        top_5_clients: res.top_5_clients || [],
        status_receivable: res.status_receivable || {},
        status_orders: res.status_orders || {},
        status_dispatch: res.status_dispatch || {},
        visits: res.visits || [],
      });
    } catch (error) {
      console.log(error);
    }
  }

  getProfile = async () => {
    try {
      const res = await UserService.getAdminProfile({ user_id: this.props.user.id });

      let remaining_days = 0;
      if (res.plan_user?.next_payment) {
        const nextPayment = moment(res.plan_user?.next_payment);
        const now = moment(res.current_date).startOf('day');
        remaining_days = nextPayment.diff(now, 'days');
        if (res?.plan_user?.plan_user?.plan) {
          res.plan_user.plan_user.plan.remaining_days = remaining_days;
        }
      }

      this.setState({
        plan: res?.plan_user?.plan_user?.plan,
        trial_expiration: res.trial_expiration,
        plan_name: res.plan_name || '',
        plan_expiration: res.plan_expiration || undefined,
        plan_free: res.plan_free || false,
        plan_user: res.plan_user || null,
        hasPendingPayments: res.has_pending_payments,
      });
    } catch (error) {
      console.log(error);
    }
  }

  toChangePlan = () => {
    if (this.state.hasPendingPayments)
      return Globals.showError('Usted presenta un pago aun por confirmar');
    this.props.history.push('/profile-business/plans');
  }

  toPay = () => {
    if (this.state.hasPendingPayments)
      return Globals.showError('Usted presenta un pago aun por confirmar');
    this.props.history.push('/profile-business/payment');
  }

  render() {
    const {
      greeting, cuentas_cobrar_pagar, orders_months, orders_totals,
      sellers_sales, top_5_products, top_5_clients,
      status_receivable, status_orders, status_dispatch, visits,
    } = this.state;

    const userName = this.props.user?.name?.split(' ')[0] || '';
    const currentYear = moment().year();
    const currentMonthLabel = moment().locale('es').format('MMMM YYYY');

    const lineLabels = orders_months.map(x => x.monthName);
    const lineData = orders_months.map(x => round2(x.amount));

    const donutLabels = top_5_products.map(x => x.name);
    const donutData = top_5_products.map(x => round2(x.quantity));
    const donutColors = top_5_products.map((_, i) => getColor(i));

    const maxClient = Math.max(...top_5_clients.map(x => x.total), 1);
    const maxSeller = Math.max(...sellers_sales.map(x => x.total), 1);

    return (
      <Menu history={this.props.history}>
        <div id="dashboard-new">

          {/* ─── EMERGENCY BANNER ─── */}
          {!!this.state.plan && this.state.plan?.remaining_days <= 5 && (
            <div id="wg--emergency">
              <img src={EmergencyIcon} alt="Plan" />
              <div className="emergency-widget-lines">
                <div className="line-1" /><div className="line-2" /><div className="line-3" />
              </div>
              <div className="emergency-widget-info">
                <p>{`Su mensualidad del ${this.state.plan?.name} de Braxo ${this.state.plan?.remaining_days < 1 ? 'está vencida' : `vencerá en ${this.state.plan?.remaining_days} ` + (this.state.plan?.remaining_days > 1 ? 'días' : 'día')}`}</p>
              </div>
            </div>
          )}

          {/* ─── GREETING ─── */}
          <div className="db-greeting">
            <h2>{greeting || 'Hola'}, {userName} 👋</h2>
            <p>Resumen general de tu operación</p>
          </div>

          {/* ─── ROW 1: 4 STAT CARDS ─── */}
          <div className="db-row db-row--4">

            {/* Total pedidos */}
            <div className="db-card db-card--blue">
              <div className="db-card__icon">📦</div>
              <div>
                <p className="db-card__label">Total de pedidos</p>
                <p className="db-card__value">${fmt(orders_totals)}</p>
                <p className="db-card__sub">
                  <img src={CalendarIcon} alt="" width={11} />
                  &nbsp;Enero – {currentMonthLabel}
                </p>
              </div>
            </div>

            {/* Plan Premium */}
            {this.props.user.level_id === Constants.ROLE_ADMIN && (
              <div className="db-card">
                <div className="db-card__icon">⭐</div>
                <div style={{ flex: 1 }}>
                  <p className="db-card__label">{this.state.plan_free ? 'Prueba Gratuita' : (this.state.plan_name || 'Plan')}</p>
                  <p className="db-card__value db-card__value--plan">
                    {this.state.plan_free ? '' : `$${fmt(this.state.plan_user?.amount)}/mes`}
                  </p>
                  {this.state.plan_expiration && (
                    <p className="db-card__sub">Próx. pago: {moment(this.state.plan_expiration).format('DD/MM/YYYY')}</p>
                  )}
                  <div className="db-card__actions">
                    <button className="db-btn db-btn--outline" onClick={this.toChangePlan}>Cambiar plan</button>
                    {this.state.plan_user?.amount > 0 && (
                      <button className="db-btn db-btn--primary" onClick={this.toPay}>Pagar</button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Cuentas por cobrar */}
            <div className="db-card">
              <div className="db-card__icon db-card__icon--pink">🧾</div>
              <div>
                <p className="db-card__label">Cuentas por cobrar</p>
                <p className="db-card__value">${fmt(cuentas_cobrar_pagar.total_cobrar)}</p>
                <p className="db-card__sub">{moment().locale('es').format('MMMM')}</p>
              </div>
            </div>

            {/* Cuentas por pagar */}
            <div className="db-card">
              <div className="db-card__icon db-card__icon--teal">🏦</div>
              <div>
                <p className="db-card__label">Cuentas por pagar</p>
                <p className="db-card__value">${fmt(cuentas_cobrar_pagar.total_pagar)}</p>
                <p className="db-card__sub">{moment().locale('es').format('MMMM')}</p>
              </div>
            </div>
          </div>

          {/* ─── ROW 2: LINE CHART + DONUT CHART ─── */}
          <div className="db-row db-row--2">

            {/* Pedidos por mes – Line chart */}
            <div className="db-widget">
              <div className="db-widget__header">
                <span className="db-widget__title">Pedidos por mes</span>
                <span className="db-widget__badge">{currentYear}</span>
              </div>
              <div className="db-widget__body" style={{ height: 220 }}>
                {orders_months.length > 0 ? (
                  <Line
                    options={{
                      maintainAspectRatio: false,
                      responsive: true,
                      plugins: {
                        legend: { display: false },
                        datalabels: { display: false },
                        tooltip: {
                          callbacks: {
                            label: (ctx) => `$${fmt(ctx.raw)}`,
                          }
                        }
                      },
                      scales: {
                        x: {
                          grid: { display: false },
                          ticks: { font: { size: 11 } },
                        },
                        y: {
                          grid: { color: '#f0f0f0' },
                          ticks: {
                            font: { size: 11 },
                            callback: (v) => `$${fmt(v)}`,
                          },
                        },
                      },
                    }}
                    data={{
                      labels: lineLabels,
                      datasets: [{
                        label: 'Pedidos',
                        data: lineData,
                        borderColor: '#4481eb',
                        backgroundColor: 'rgba(68,129,235,0.12)',
                        fill: true,
                        tension: 0.4,
                        pointRadius: 4,
                        pointBackgroundColor: '#4481eb',
                      }],
                    }}
                  />
                ) : (
                  <p className="db-empty">Sin datos este año</p>
                )}
              </div>
            </div>

            {/* Top 5 productos – Donut + leyenda */}
            <div className="db-widget">
              <div className="db-widget__header">
                <span className="db-widget__title">Top 5 productos</span>
                <span className="db-widget__sub">{moment().startOf('month').format('MMM D')} - {moment().format('MMM D')}</span>
              </div>
              <div className="db-widget__body db-donut-layout">
                <div style={{ width: 160, flexShrink: 0 }}>
                  {top_5_products.length > 0 ? (
                    <Doughnut
                      options={{
                        maintainAspectRatio: true,
                        responsive: true,
                        cutout: '65%',
                        plugins: {
                          legend: { display: false },
                          datalabels: { display: false },
                          tooltip: {
                            callbacks: {
                              label: (ctx) => ` ${ctx.label}: ${ctx.raw} uds`,
                            }
                          }
                        },
                      }}
                      data={{
                        labels: donutLabels,
                        datasets: [{
                          data: donutData,
                          backgroundColor: donutColors,
                          borderColor: donutColors,
                          borderWidth: 2,
                        }],
                      }}
                    />
                  ) : (
                    <p className="db-empty">Sin datos</p>
                  )}
                </div>
                <div className="db-donut-legend">
                  {top_5_products.map((p, i) => (
                    <div key={i} className="db-donut-legend__item">
                      <span className="db-donut-legend__dot" style={{ background: getColor(i) }} />
                      <span className="db-donut-legend__name" title={p.name}>{p.name}</span>
                      <span className="db-donut-legend__val">{p.quantity} uds</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ─── ROW 3: STATUS COUNTERS + VISITS TABLE ─── */}
          <div className="db-row db-row--status-visits">

            {/* Status counters */}
            <div className="db-widget db-widget--status">
              {/* Cuentas por cobrar */}
              <div className="db-status-group">
                <div className="db-status-group__header">
                  <span className="db-status-group__icon">🧾</span>
                  <span className="db-status-group__title">Cuentas por cobrar</span>
                </div>
                <div className="db-status-row">
                  {Object.entries(status_receivable).map(([label, val], i) => (
                    <div key={i} className={`db-status-item db-status-item--${i === 0 ? 'blue' : i === 1 ? 'red' : 'green'}`}>
                      <span className="db-status-item__val">{val}</span>
                      <span className="db-status-item__label">{label}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="db-divider" />
              {/* Pedidos */}
              <div className="db-status-group">
                <div className="db-status-group__header">
                  <span className="db-status-group__icon">📦</span>
                  <span className="db-status-group__title">Pedidos</span>
                </div>
                <div className="db-status-row">
                  {Object.entries(status_orders).map(([label, val], i) => (
                    <div key={i} className={`db-status-item db-status-item--${i === 0 ? 'blue' : i === 1 ? 'green' : 'red'}`}>
                      <span className="db-status-item__val">{val}</span>
                      <span className="db-status-item__label">{label}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="db-divider" />
              {/* Despacho */}
              <div className="db-status-group">
                <div className="db-status-group__header">
                  <span className="db-status-group__icon">🚚</span>
                  <span className="db-status-group__title">Despacho</span>
                </div>
                <div className="db-status-row">
                  {Object.entries(status_dispatch).map(([label, val], i) => (
                    <div key={i} className={`db-status-item db-status-item--${i === 0 ? 'blue' : 'green'}`}>
                      <span className="db-status-item__val">{val}</span>
                      <span className="db-status-item__label">{label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Visitas planificadas */}
            <div className="db-widget db-widget--visits">
              <div className="db-widget__header">
                <span className="db-widget__title">Visitas Planificadas/vendedor</span>
                <span className="db-widget__sub">{moment().format('D [de] MMMM YYYY')}</span>
              </div>
              <div className="db-visits-legend">
                <span className="db-visits-legend__item" style={{ color: '#4481eb' }}>● Planificadas</span>
                <span className="db-visits-legend__item" style={{ color: '#f7b731' }}>● Pendientes</span>
                <span className="db-visits-legend__item" style={{ color: '#20bf6b' }}>● Finalizadas</span>
                <span className="db-visits-legend__item" style={{ color: '#fc5c65' }}>● No realizadas</span>
              </div>
              {visits.length === 0 ? (
                <p className="db-empty" style={{ padding: '1rem' }}>Sin visitas planificadas para hoy</p>
              ) : (
                <div className="db-visits-table">
                  {visits.map((v, i) => (
                    <div key={i} className="db-visit-row">
                      <div className="db-visit-info">
                        <p className="db-visit-seller">{v.seller}</p>
                        <p className="db-visit-clients">{v.planificadas} clientes</p>
                      </div>
                      <div className="db-visit-progress-col">
                        <span className="db-visit-progress-label">Cumplimiento de ruta</span>
                        <div className="db-visit-bar-wrap">
                          <div
                            className="db-visit-bar"
                            style={{
                              width: `${v.progress_percent}%`,
                              background: v.progress_percent >= 80 ? '#20bf6b' : v.progress_percent >= 50 ? '#f7b731' : '#fc5c65',
                            }}
                          />
                        </div>
                        <span className="db-visit-pct">{v.progress_percent}%</span>
                      </div>
                      <div className="db-visit-counts">
                        <div className="db-visit-count db-visit-count--blue">
                          <span>{v.planificadas}</span>
                          <small>Planificadas</small>
                        </div>
                        <div className="db-visit-count db-visit-count--yellow">
                          <span>{v.pendientes}</span>
                          <small>Pendientes</small>
                        </div>
                        <div className="db-visit-count db-visit-count--green">
                          <span>{v.finalizadas}</span>
                          <small>Finalizadas</small>
                        </div>
                        <div className="db-visit-count db-visit-count--red">
                          <span>{v.no_realizadas}</span>
                          <small>No realizadas</small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* ─── ROW 4: TOP CLIENTS + SELLERS ─── */}
          <div className="db-row db-row--2">

            {/* Top 5 Clientes */}
            <div className="db-widget">
              <div className="db-widget__header">
                <span className="db-widget__title">Top 5 Clientes con más compras</span>
                <span className="db-widget__sub">{moment().startOf('month').format('MMM D')} - {moment().format('MMM D [YYYY]')}</span>
              </div>
              <div className="db-widget__body">
                {top_5_clients.length === 0 ? (
                  <p className="db-empty">Sin datos este mes</p>
                ) : (
                  <div className="db-hbar-list">
                    {top_5_clients.map((c, i) => (
                      <div key={i} className="db-hbar-row">
                        <span className="db-hbar-name" title={c.name}>{c.name}</span>
                        <div className="db-hbar-track">
                          <div
                            className="db-hbar-fill"
                            style={{
                              width: `${Math.round((c.total / maxClient) * 100)}%`,
                              background: getColor(i),
                            }}
                          />
                        </div>
                        <span className="db-hbar-val">${fmt(c.total)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Ventas por Vendedor */}
            <div className="db-widget">
              <div className="db-widget__header">
                <span className="db-widget__title">Ventas de Vendedores</span>
                <span className="db-widget__sub">{moment().startOf('month').format('MMM D')} - {moment().format('MMM D [YYYY]')}</span>
              </div>
              <div className="db-widget__body">
                {sellers_sales.length === 0 ? (
                  <p className="db-empty">Sin datos este mes</p>
                ) : (
                  <div className="db-hbar-list">
                    {sellers_sales.map((s, i) => (
                      <div key={i} className="db-hbar-row">
                        <span className="db-hbar-name" title={s.name}>{s.name}</span>
                        <div className="db-hbar-track">
                          <div
                            className="db-hbar-fill"
                            style={{
                              width: `${Math.round((s.total / maxSeller) * 100)}%`,
                              background: getColor(i),
                            }}
                          />
                        </div>
                        <span className="db-hbar-val">${fmt(s.total)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
      </Menu>
    );
  }
}

export default connect(state => ({
  user: state.user,
}))(Dashboard);